// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Read config from Vite env vars so we can switch dev/prod by build env
export const firebaseConfig = {
  apiKey: "AIzaSyC2Em02ZlddmTdbGmhJ6M19lusweAUI4SA",
  authDomain: "trelli-prod-473722.firebaseapp.com",
  projectId: "trelli-prod-473722",
  storageBucket: "trelli-prod-473722.firebasestorage.app",
  messagingSenderId: "3937973541",
  appId: "1:3937973541:web:136d684309c8927b1596cc",
};

// Avoid re-initializing during hot reload
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Core services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Persist login across reloads
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.error("Auth persistence error:", err);
});

export { app, auth, db, storage };